<div class="two-column-table">
  <div class="row">
    <div class="row-th" *ngIf="classificationMethod === 'PRODUCT_GROUP'">Product Group</div>
    <div class="row-th" *ngIf="classificationMethod === 'CBF'">CBF</div>
    <div class="row-th" *ngIf="classificationMethod === 'CBF'">Description</div>
    <div class="row-th">Purchase Amounts</div>
  </div>
  <div
    class="row"
    *ngFor="let data of dataList"
  >
    <div class="row-td" *ngIf="data.productGroup">{{ data.productGroup }}</div>
    <div class="row-td" *ngIf="data.cbf">{{ data.cbf }}</div>
    <div class="row-td" *ngIf="data.cbf">
      <input nz-input [(ngModel)]="data.description" style="height: 35px;"/>
    </div>
    <div class="row-td">
      <sales-portal-input-number
        [disabled]="splittingMethod === 'automaticallySplitting'"
        [(ngModel)]="data.targetAmount"
        [height]="'35px'"
        style="width: 100%"
      ></sales-portal-input-number>
    </div>
  </div>

</div>
